import { Checkbox } from '@liveauctioneers/hammer-ui-core/checkbox';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';

import { useFlatFacetOptions } from '@/pages/Search/SearchPage/hooks/useFlatFacetOptions';
import { useServerSideFacetExpansion } from '@/pages/Search/SearchPage/hooks/useServerSideFacetExpansion';
import { CurrentOpenMenu, STANDARD_VIEW_MORE_SIZE } from '@/pages/Search/SearchPage/types';
import { getRoundedNumberText } from '@/pages/Search/SearchPage/utils/getRoundedNumberText';
import FacetTypes from '@/types/search/enums/facetTypes';
import { FilterAction } from '@/types/SearchFacet';

import { FacetCard } from '../FacetCard/FacetCard';

export const MaterialFilter = () => {
    const { formatMessage } = useIntl();
    const { isLoading, onViewMoreClick } = useServerSideFacetExpansion({
        facetId: FacetTypes.MATERIALS_AND_TECHNIQUES_ID,
        size: STANDARD_VIEW_MORE_SIZE,
    });
    const { filteredOptions, isOptionChecked, onOptionClick } = useFlatFacetOptions({
        currentOpenMenu: CurrentOpenMenu.AllFilters,
        facetId: FacetTypes.MATERIALS_AND_TECHNIQUES_ID,
        filterActionChanged: FilterAction.MaterialsAndTechniquesChanged,
        filterActionRemoved: FilterAction.MaterialsAndTechniquesRemoved,
    });

    if (filteredOptions.length === 0) {
        return null;
    }

    return (
        <FacetCard
            headline={formatMessage({ id: 'searchPage.facets.materialsAndTechniques' })}
            isLoading={isLoading}
            onViewMoreClick={onViewMoreClick}
            testid="material-filter"
        >
            {filteredOptions.map((option) => (
                <Checkbox.Option
                    checked={isOptionChecked(option)}
                    disabled={option.count === 0 && !isOptionChecked(option)}
                    key={option.id}
                    onChange={() => {
                        onOptionClick(option);
                    }}
                >
                    {option.name} ({getRoundedNumberText({ totalFound: option.count })})
                </Checkbox.Option>
            ))}
        </FacetCard>
    );
};
